
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","fill-opacity":".01","d":"M0 0h50v50H0z"}}),_c('circle',{attrs:{"cx":"25","cy":"25","r":"25","fill":"#F0F0EB"}}),_c('path',{attrs:{"d":"M35.382 7.928h-20.87v34.125h20.873V31.172h-12.96v-4.107h8.41v-4.153h-8.41v-4.103h12.96V7.928h-.003z","fill":"#008009"}})])
          )
        }
      }
    